export default "/images/ae90a9d8346c45655ff123ef139470a0.png";